import { render, staticRenderFns } from "./JiangsuMobileElm01.vue?vue&type=template&id=ce1702cc&scoped=true"
import script from "./JiangsuMobileElm01.vue?vue&type=script&lang=js"
export * from "./JiangsuMobileElm01.vue?vue&type=script&lang=js"
import style0 from "./JiangsuMobileElm01.vue?vue&type=style&index=0&id=ce1702cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1702cc",
  null
  
)

export default component.exports